<template>
  <div>
    <div class="row pb-3">
      <div class="col-sm-12">
        <h4 class="font-weight-bold">Histórico de participações em Atividades</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <loading-animation
          :active.sync="loading"
          :is-full-page="false"
          :opacity="1"
          color="#5895FF"
        />
        <b-table
          :fields="[
            {
              key: 'atividade',
              label: $t('Detalhes'),
            },
            {
              key: 'cadastrado',
              label: $t('Inscrito em'),
            },
            {
              key: 'status',
              label: $t('Status'),
            },
          ]"
          :items="itemList"
          :responsive="true"
          striped
          hover
          show-empty
          small
          outlined
          stacked="md"
          table-class="mb-3"
        >
          <template v-slot:cell(atividade)="data">
            Usuário:
            <strong v-if="data.item.usuario">
              {{ data.item.usuario.nome_completo }}
              <b-link
                :to="'/dashboard/usuario/edit/' + data.item.usuario.id"
                target="_blank"
              >
                <i class="fas fa-external-link-alt"></i>
              </b-link>
            </strong>
            <br />
            Atividade:
            <strong v-if="data.item.atividade">
              {{ data.item.atividade.titulo }}
            </strong>
          </template>
          <template v-slot:cell(cadastrado)="data">
            <strong>{{ data.value }}</strong>
          </template>
          <template v-slot:cell(status)="data">
            <span v-html="data.item.status_nome"></span>
          </template>

          <template v-slot:cell()="data"> </template>
          <template v-slot:empty="scope">
            <div class="text-center my-5">
              <img
                :alt="$t('No results')"
                class="mb-5"
                src="/img/icons/robot.svg"
                style="max-height: 165px"
              />
              <h3 class="bold">{{ $t("No records found") }}</h3>
            </div>
          </template>
        </b-table>

        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="form-group d-inline-flex mb-0">
              <select
                class="form-control"
                style="width: 70px"
                v-model="perPage"
                v-on:change="getItens"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>
            <div class="d-inline-flex ml-2">
              <b-pagination
                :per-page="perPage"
                :total-rows="pagination.total"
                @change="changePage"
                v-model="page"
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div class="float-lg-right">
              {{ $t("Showing page") }}
              {{ pagination.currentPage }}
              de
              {{ pagination.totalPages }}
              {{ $t("pages in") }}
              {{ pagination.total }}
              {{ $t("records") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {
      page: 1,
      perPage: 10,
      loading: true,
      search: "",
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      itemList: [],
    };
  },
  mounted() {
    this.getItens();
  },
  methods: {
    changePage(page) {
      if (page > 0 && page <= this.pagination.totalPages && page !== this.page) {
        this.page = page;
        this.getItens();
      }
    },
    getItens() {
      this.loading = true;
      axios
        .get("api/dashboard/atividadesvinculo/usuario", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            usuario: this.item.id,
          },
        })
        .then((response) => {
          this.user_id = this.$store.state.user.id;
          this.itemList = response.data.dados;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getItens();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
